export default {
  data() {
    return {
      drawLotsState: 0, // 0 不能操作，1 抽签 2 查看
      drawType: 2, // 0 线上 1 线下 2 未选择
    }
  },

  computed: {
    checkDrawLots() {
      return this.drawLotsState === 2
    }
  },

  methods: {
    async initDrawState() {
      await this.getDrawLotsState()
      if (this.drawLotsState !== 0) {
        await this.getDrawTypeState()
      }
    },

    async getDrawLotsState() {
      try {
        const { data } = await this.$api.getDrawButtonStatus();
        this.drawLotsState = data.data;
      } catch(err) {
        console.error('getDrawButtonStatus fail', err);
      }
    },

    async getDrawTypeState() {
      try {
        const { data } = await this.$api.getDrawTypeState();
        this.drawType = data.data;
      } catch(err) {
        console.error('getDrawTypeState fail', err);
      }
    }
  }
}